import React, { useState, useEffect, useContext, useRef } from 'react'
import { Growl } from 'primereact/growl'
import { Message } from 'primereact/message'
import { useLocation, useHistory } from 'react-router-dom'
import { UserService } from '../../services/User'
import { VirtualMachineService } from '../../services/VirtualMachine'
import { Layout } from '../../components/Layout'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { CoursesService } from '../../services/Courses'
import { LaboratoryService } from '../../services/Laboratory'
import { PodsService } from '../../services/Pods'
import { ProgramService } from '../../services/Program'
// import { Carousel } from '../../components/Carousel'
import './styles.scss'

export const Dashboard = () => {
  const history = useHistory()
  const { isAuth: token, userLogged } = useContext(Context)
  const [users, setUsers] = useState([])
  const [virtualMachines, setVirtualMachines] = useState([])
  const [courses, setCourses] = useState([])
  const [laboratories, setLaboratories] = useState([])
  const [pods, setPods] = useState([])
  const [programs, setPrograms] = useState([])
  const [isLoading, setIsLoading] = useState(null)
  const [error, setError] = useState(null)
  const location = useLocation()
  const growlRef = useRef(null)

  const fetchData = async () => {
    setIsLoading(true)
    try {
      if (
        userLogged.role === GLOBALS.roles.admin.id ||
        userLogged.role === GLOBALS.roles.teacher.id
      ) {
        const [userData, virtualMachineData, CoursesData, LaboratoryData, PodData, Program] =
          await Promise.all([
            await UserService.getAll(token),
            await VirtualMachineService.getAll(token),
            await CoursesService.getAll(token),
            await LaboratoryService.getAll(token),
            await PodsService.getAll(token),
            await ProgramService.getAll(token),
          ])
        setUsers(userData)
        setCourses(CoursesData)
        setVirtualMachines(virtualMachineData)
        setLaboratories(LaboratoryData)
        setPods(PodData)
        setPrograms(Program)
      }
    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  // const carouselImages = [
  //   {
  //     src: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/assets/layout/images/slider1.png`,
  //     alt: 'Descripción de la imagen 1',
  //   },
  //   {
  //     src: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/assets/layout/images/slider2.png`,
  //     alt: 'Descripción de la imagen 2',
  //   },
  //   {
  //     src: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/assets/layout/images/slider3.png`,
  //     alt: 'Descripción de la imagen 3',
  //   },
  // ]

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (location.state && location.state.success && growlRef) {
      growlRef.current.show({
        severity: 'success',
        summary: 'Bien!',
        detail: location.state.message || '',
      })
    }
  }, [location.state, growlRef])

  const goToUrl = (link) => {
    history.push({
      pathname: link,
    })
  }

  return (
    <Layout>
      <Growl ref={growlRef}> </Growl>
      {isLoading ? (
        <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error} style={{ marginBottom: '20px' }}>
          {' '}
        </Message>
      ) : userLogged.role === GLOBALS.roles.admin.id ? (
        <div className="p-grid p-fluid dashboard">
          <div
            onClick={() => goToUrl(GLOBALS.menu.users.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Usuarios </span>
              <span className="detail"> Registrados</span>
              <span className="count visitors"> {users.length} </span>
            </div>
          </div>

          <div
            onClick={() => goToUrl(GLOBALS.menu.courses.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Cursos </span>
              <span className="detail"> Registrados</span>
              <span className="count visitors"> {courses.length} </span>
            </div>
          </div>

          <div
            onClick={() => goToUrl(GLOBALS.menu.laboratories.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Laboratorios </span>
              <span className="detail"> Registrados</span>
              <span className="count visitors"> {laboratories.length} </span>
            </div>
          </div>

          <div
            onClick={() => goToUrl(GLOBALS.menu.pods.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> PODS </span>
              <span className="detail">Registrados </span>
              <span className="count purchases"> {pods.length} </span>
            </div>
          </div>

          <div
            onClick={() => goToUrl(GLOBALS.menu.remoteresource.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Recursos </span>
              <span className="detail"> Registrados </span>
              <span className="count purchases"> {virtualMachines.length} </span>
            </div>
          </div>

          {/*                     <div onClick={() => goToUrl(GLOBALS.menu.programs.linkList)} className="p-col-12 p-lg-6 divButton" >
                        <div className="card summary" >
                            <span className="title" > Programas </span>
                            <span className="detail" > Registrados </span>
                            <span className="count purchases" > {programs.length} </span>
                        </div>
                    </div> */}
        </div>
      ) : userLogged.role === GLOBALS.roles.student.id ? (
        <>
          {/* <Carousel images={carouselImages} /> */}
          <div className="p-grid p-fluid dashboard margin">
            <div
              onClick={() => goToUrl(GLOBALS.menu.courses.linkList)}
              className="p-col-12 p-lg-6 divButton"
            >
              <div className="card summary">
                <span className="title"> Mis Cursos </span>
                <span className="count visitors"> {`>`} </span>
              </div>
            </div>
            <div
              onClick={() => goToUrl(GLOBALS.menu.reserve.linkList)}
              className="p-col-12 p-lg-6 divButton"
            >
              <div className="card summary">
                <span className="title"> Mis Reservas </span>
                <span className="count visitors"> {`>`} </span>
              </div>
            </div>
          </div>
        </>
      ) : userLogged.role === GLOBALS.roles.teacher.id ? (
        <div className="p-grid p-fluid dashboard">
          <div
            onClick={() => goToUrl(GLOBALS.menu.courses.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Cursos </span>
              <span className="detail"> Registrados</span>
              <span className="count visitors"> {courses.length} </span>
            </div>
          </div>

          <div
            onClick={() => goToUrl(GLOBALS.menu.reserve.linkList)}
            className="p-col-12 p-lg-6 divButton"
          >
            <div className="card summary">
              <span className="title"> Mis Reservas </span>
              <span className="detail"> Registradas</span>
              <span className="count visitors"> {`>`} </span>
            </div>
          </div>

          {/*                     <div onClick={() => goToUrl(GLOBALS.menu.programs.linkList)} className="p-col-12 p-lg-6 divButton" >
                        <div className="card summary" >
                            <span className="title" > Programas </span>
                            <span className="detail" > Registrados </span>
                            <span className="count purchases" > {programs.length} </span>
                        </div>
                    </div> */}
        </div>
      ) : (
        <>
          {/* <Carousel images={carouselImages} /> */}
          <div className="p-grid p-fluid dashboard margin">
            <div
              onClick={() => goToUrl(GLOBALS.menu.courses.linkList)}
              className="p-col-12 p-lg-6 divButton"
            >
              <div className="card summary">
                <span className="title"> Mis Cursos </span>
                <span className="count visitors"> {`>`} </span>
              </div>
            </div>
          </div>
        </>
      )}{' '}
    </Layout>
  )
}
